import { Dialog } from "construct-ui";
import paginationComponent from '../../components/pagination/pagination.component';
import languageModel from '../../models/language.model';
import goodMovementModel from '../../models/posm/goods-movement.model';
import ViewBase from "../view-base.view";
export function POSMWareHouseManagement() {
  ViewBase.call(this);
  let warehouses = []
  let searchText = ""
  let totalItems = 0;
  let pageSize = 10;
  let pageIndex = 1;
  let isCreateDialogOpen = false;
  let selectedWarehouse = {};
  const getAllWareHouse = (warehouseSearchText = "") => {
    this.showLoading();
    goodMovementModel.getCommonForPopup({ DataType: 'POSM_WAREHOUSE', DataCode: '', DataName: warehouseSearchText, ParameterDataCode: '', PageSize: pageSize, PageIndex: pageIndex }).then((data) => {
      totalItems = data.total
      warehouses = data.data.map((item, index) => {
        return { ...item, order: index }
      });

    }).catch((err) => {
      this.handleError(err);
    }).finally(
      () => {
        this.hideLoading();
      }
    );
  }
  const onSearch = (text) => {
    pageIndex = 1;
    pageSize = 10;
    getAllWareHouse(text);
  }
  const onInput = (e) => {
    selectedWarehouse = { ...selectedWarehouse, name: e.target.value }
  }
  const handleClickDelete = (item) => {
    this.showConfirm(
      this.getText("EM00000265", "Are you sure you want to delete?"),
      this.getText("LT00000373", "Remove Selected"),
      e => {
        if (e == "YES") {
          this.showLoading();
          goodMovementModel.deleteWarehouse(item.code).then((data) => {
            if (data[0].transStatus == "SUCCESS") {
              this.showMessage('success', null, () => {
                getAllWareHouse()
              });
            } else {
              this.showErrorMessage(data[0].message, null, () => {
              })
            }
          }).catch((err) => {
            this.handleError(err);
          })
            .finally(() => {
              this.hideLoading()
            })
        }
      }
    )
  }
  const handleClickUpdate = (item) => {
    isCreateDialogOpen = true;
    selectedWarehouse = item;
  }
  const onSave = (e) => {
    e.preventDefault();
    if (!this.validateForm(e)) {
      return false;
    }
    this.showLoading();
    goodMovementModel.updateWarehouse(selectedWarehouse.code, selectedWarehouse.name).then((data) => {
      if (data[0].transStatus == "SUCCESS") {
        this.showMessage('success', null, () => {
          isCreateDialogOpen = false;
          getAllWareHouse();
        });
      } else {
        this.showErrorMessage(data[0].message, null, () => {
        })
      }
    }).catch((err) => {
      this.handleError(err);
    })
      .finally(() => {
        this.hideLoading()
      })
  }
  return {
    oninit: () => {
      getAllWareHouse();

    },
    view: () => [
      m('.card.mb-3',
        m('.card-body',
          m('.position-relative',
            m('.row.row-cols-5.g-2.mb-2',
              m('.col.position-relative', [
                m('label.form-label', this.getText("LT00001269", "Warehouse")),
                m('.input-group', { "style": "min-width : 650px ;" },
                  m('input[type=text][placeholder=' + this.getText("LT00001269", "Warehouse") + '].form-control.form-control-bg', {
                    oninput: (e) => {
                      searchText = e.target.value;
                    },
                    value: searchText,
                    maxlength: 300,
                    "style": "border-radius : 5px ;"
                  }),

                  m('.col-4.d-flex.justify-content-end.gap-2', { "style": "background: white;" },
                    m(
                      'button.btn.btn-primary',
                      {
                        onclick: () => {
                          onSearch(searchText)
                        },
                      },
                      this.getText('LT00000001', 'Search')
                    ),
                    m(
                      'button.btn.btn-white',
                      {
                        onclick: () => {
                          searchText = "";
                        },
                      },
                      this.getText('LT00000031', 'Clear')
                    )
                  )
                ),

              ]),

            )))),
      [
        m('.row',
          m('.col-12.attendance',
            m('.card',
              m('.card-body',
                m('.d-flex.justify-content-end.gap-3.mb-2',

                ),
                m('.row',
                  m(".col-12.p-0",
                    m(".table-responsive",
                      m("table.table.table-hover.table-bordered", [
                        m("thead.thead-bggrey", { "style": "position : sticky ; top :1px; box-shadow: 0px -1px var(--is-link-blue)" },

                          m("tr.align-middle", { style: 'box-shadow: 0px 1px var(--blue-color-light)' }, [
                            m("th", { "scope": "col", "colspan": "1", "style": "text-align :center;width:100px;" }, "Action"),
                            m("th", { "scope": "col", "colspan": "1", "style": "text-align :center;" }, "Warehouse Name"),
                          ]),

                        ),
                        m("tbody",
                          (warehouses.length === 0) &&
                          m("tr", { "class": "align-middle" },
                            m("td", { "colspan": 2 }, languageModel.getText("EM00000141", "No records found."))
                          ),
                          warehouses.length > 0 &&
                          warehouses.map((att, index) => {
                            return [
                              m("tr.align-middle", [m("td", { "style": "text-align :center; max-width:100px;" }, [m('i.bi.bi-trash-fill.list-action-icon[title="Delete"]', {
                                onclick: () => { handleClickDelete(att) }
                              }), m(
                                'i.bi.bi-pencil-square.list-action-icon[title="Edit"]', { onclick: () => { handleClickUpdate(att) } }),]), m("td", att.name)]),
                            ]

                          }),
                        )
                      ])
                    ),
                    warehouses.length > 0 &&
                    m(".px-3",
                      m(paginationComponent, {
                        currentPage: pageIndex,
                        pageSize: pageSize,
                        totalItems: totalItems,
                        onPageChanged: (newPageIndex) => {
                          pageIndex = newPageIndex;
                          getAllWareHouse(searchText);

                        },
                        onPageSizeChanged: (newPageIndex, newPageSize) => {
                          pageIndex = newPageIndex;
                          pageSize = newPageSize;
                          getAllWareHouse(searchText)
                        },
                      })
                    )
                  )
                )
              )
            )
            //End List
          ),
        ),
        m(Dialog, {
          isOpen: isCreateDialogOpen,
          closeOnOutsideClick: false,
          closeOnEscapeKey: false,
          title: this.getText("LT00001269", "Warehouse"),
          class: 'cui-dialog-xxl',
          onClose: () => {
            isCreateDialogOpen = false;
          },
          content: m('.card',
            m('.card-body',
              m('form.needs-validation[novalidate]', { id: 'form', onsubmit: onSave },
                m('.row.g-2',
                  m('.col-md-12.position-relative',
                    m('label.form-label.mandatory[for="input"]',
                      `${this.getText("LT00001269", "Warehouse")}`
                    ),
                    m(`input#input.form-control.form-control-bg[required][type=text][placeholder=${this.getText("LT00001269", "Warehouse")}]`
                      , {
                        maxlength: 100,
                        defaultValue: selectedWarehouse.name,
                        oninput: (e) => {
                          onInput(e)
                        }
                      }
                    ),
                    m('.invalid-tooltip', this.getText('LT00000903', 'Please check required fields')),
                  ),
                )
              )
            ),

          ),
          footer: m('row',
            m('.col-12.d-flex.justify-content-end.gap-2',
              m('button.btn.btn-primary',
                {
                  type: 'submit',
                  form: 'form',
                },
                this.getText('LT00000022', 'Save')
              ),
              m('button.btn.btn-white',
                {
                  onclick: () => {
                    isCreateDialogOpen = false;
                  },
                },
                this.getText('LT00000021', 'Close')
              )
            )
          ),
        }),
      ],
      this.getBaseViews(),
    ],

  }
}